import { CoreColorScheme } from '../types/color-scheme.types';

export function convertSchemeNameToColors(schemeName: string): CoreColorScheme {
  const COLOR_SCHEME_PREFIX = 'color-scheme-';
  if (!schemeName) {
    return {} as CoreColorScheme;
  }

  return {
    background: formatColorValue(
      `${COLOR_SCHEME_PREFIX}${schemeName}-background`
    ),
    foreground: {
      primary: formatColorValue(
        `${COLOR_SCHEME_PREFIX}${schemeName}-foreground-primary`
      ),
      secondary: formatColorValue(
        `${COLOR_SCHEME_PREFIX}${schemeName}-foreground-secondary`
      ),
      highlight: formatColorValue(
        `${COLOR_SCHEME_PREFIX}${schemeName}-foreground-highlight`
      ),
    },
  };
}

/**
 * At this point, the team is still planning on how to integrate
 * other brand token into the system, but before that, it will be
 * hex code instead of a variable, therefore this function is to make sure
 * that it can handle both scenarios
 * @param color can be either a hex code or variable
 * @returns the formatted value
 */
function formatColorValue(color: string): string {
  return color.includes('#') ? color : `var(--${color})`;
}
